export function windowOpen(url: string, width: number, height: number) {
    const x = ($(window).width() - width) / 2;
    const y = ($(window).height() - height) / 2;
    // eslint-disable-next-line max-len
    const params = `toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,width=${width},height=${height},left=${x},top=${y}`;

    return window.open(url, '_blank', params);
}

export function createIframe(
    url: string,
    inWidth: number,
    inHeight: number,
    div?: boolean,
    measureType?: string
): HTMLIFrameElement {
    let element = 'iframe';

    if (div) {
        element = 'div';
    }

    const target: HTMLIFrameElement = document.createElement(element) as HTMLIFrameElement;
    const width: number = inWidth || 600;
    const height: number = inHeight || 530;


    target.id = 'js-order_box_iframe';
    target.name = 'js-order_box_iframe';
    target.style.width = `${width}px`;
    target.style.height = `${height}px`;
    if (measureType) {
        target.style.width = `${width}${measureType}`;
        target.style.height = `${height}${measureType}`;
    }
    // @ts-ignore
    target.setAttribute('noResize', true);

    if (!div) {
        (<HTMLIFrameElement>target).src = url;
    }

    return target;
}

$.prototype.scrollbar = ((jQueryScrollbar) => {
    return function scrollbar() {
        const isMac = window.app.config.user_os.name.toLowerCase().includes('mac');
        const isFirefox = window.app.config.user_browser.name.toLowerCase().includes('firefox');
        if (!(isMac && isFirefox)) {
            return jQueryScrollbar.call(this);
        } else {
            $(this).css('overflow-y', 'auto');
        }
    };
})($.prototype.scrollbar);


